export default [
    {
        name: "login",
        path: "/login",
        component: () => import("@/views/login/Login"),
        meta: { layout: "Blank", menu: "", title: "Dot Apps : Sign in"}
    },
    {
        name: "find-ID",
        path: "/findId",
        component: () => import("@/views/login/FindId"),
        meta: { layout: "Blank", menu: "", title: "Dot Apps : Find Username" }
    },
    {
        name: "find-password",
        path: "/findPwd",
        component: () => import("@/views/login/FindPwd"),
        meta: { layout: "Blank", menu: "", title: "Dot Apps : Reset Password" }
    },
    {
        name: "join",
        path: "/join",
        component: () => import("@/views/login/Join"),
        meta: { layout: "Blank", menu: "", title: "Dot Apps : Sign up" }
    },
];
